/* eslint-disable import/no-cycle */
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'

import useElementOnScreen from '../../hooks/useElementOnScreen'
import { CtaButton, Image, VideoComponent } from '..'
import richTextRenderer from '../RichTextParser/RichTextParser'
import { Kicker } from '../Typography'
import {
  backdrop,
  backdropOpen,
  closeIcon,
  fontColor,
  playIcon,
  reviewContent,
  reviewContentContainer,
  reviewImage,
  reviewItem,
  reviewName,
  reviewTitle,
  treatmentTitle,
  videoOverLay,
  videoPopup,
  videoPopupOpen,
} from './ReviewItem.module.css'

const ReviewItem = ({ isDesktop, review }) => {
  const {
    content,
    cta,
    kicker,
    name,
    staticimage,
    title,
    treatment,
    videolink,
  } = review
  const [openVideo, setOpenVideo] = useState(false)
  const [mobileVideo, setMobileVideo] = useState(false)
  let ctaContent = cta
  if (typeof cta === 'string') {
    ctaContent = JSON.parse(cta)
  }
  const [setRef, visible] = useElementOnScreen()
  const closeModal = () => {
    if (typeof document !== 'undefined') {
      // eslint-disable-next-line no-undef
      const videoPlayer = document.getElementById('videoframe')
      if (videoPlayer) {
        videoPlayer.contentWindow.postMessage(
          // eslint-disable-next-line no-useless-concat
          '{"event":"command","func":"' + 'stopVideo' + '","args":""}',
          '*',
        )
      }
    }
    setOpenVideo(false)
  }

  useEffect(() => {
    if (!visible) {
      closeModal()
    }
  }, [visible])

  const playVideo = () => {
    if (isDesktop) {
      setOpenVideo(true)
    } else {
      setMobileVideo(true)
    }
  }

  return (
    <>
      <div className={reviewItem}>
        <div className={reviewContentContainer}>
          <div className={reviewImage}>
            {staticimage && !mobileVideo && (
              <Image
                alt="review"
                className={`${reviewImage}`}
                placeholder="none"
                src={staticimage.node.localFile.childImageSharp}
              />
            )}
            {staticimage && videolink && !mobileVideo && (
              <>
                {' '}
                <div
                  className={videoOverLay}
                  onClick={() => playVideo()}
                  role="presentation"
                />
                <StaticImage
                  alt="icon"
                  className={playIcon}
                  src="../../assets/icons/playBtn.svg"
                />
              </>
            )}
            {!isDesktop && videolink && mobileVideo && (
              <VideoComponent
                className={`${reviewImage}`}
                videoID={videolink.url.split('=')[1]}
              />
            )}
          </div>
          {videolink && openVideo && (
            <div
              ref={setRef}
              className={`${videoPopup} ${openVideo ? videoPopupOpen : ''}`}
            >
              <VideoComponent videoID={videolink.url.split('=')[1]} />
              <div
                className={closeIcon}
                onClick={() => closeModal()}
                role="presentation"
              >
                <StaticImage
                  alt="icon"
                  className={closeIcon}
                  src="../../assets/icons/closeIcon.svg"
                />
              </div>
            </div>
          )}
          {kicker && <Kicker extraClassName={fontColor}>{kicker}</Kicker>}
          {name && <h3 className={reviewName}>{name}</h3>}
          {/* <div className={divider} /> */}
          {treatment && <p className={treatmentTitle}>{treatment}</p>}
          {title && <p className={reviewTitle}>{title}</p>}
          {/* <div className={divider} /> */}
          {content && (
            <div className={reviewContent}>{richTextRenderer(content)}</div>
          )}
        </div>
        {cta && <CtaButton {...ctaContent} />}
      </div>
      <div
        className={`${backdrop} ${openVideo ? backdropOpen : ''}`}
        role="presentation"
      />
    </>
  )
}

export default ReviewItem
